<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['common_habit'] }} <span class="text-12-400 ri-ps-2 ri-pe-3">{{
            ss.getFormattedDate(data.dateString, 'd MMM y, EEE') }}</span></h6>
    <div class="flex items-center gap-6">
        <!-- Dynamically rendered top bar actions (no static checks in loop) -->
        @for (action of topBarActionsWithoutSpecial(); track action.id) {
        <app-svg [name]="action.icon" (click)="executeAction(action)" role="button" [color]="ss.theme().color12">
        </app-svg>
        }

        <!-- Kebab menu trigger (only if has items) -->
        @if (kebabAction() && showKebabMenu()) {
        <app-svg [name]="kebabAction()!.icon" [class]="kebabAction()!.customClass" [matMenuTriggerFor]="infoMenu"
            role="button" [color]="ss.theme().color12">
        </app-svg>
        }

        <!-- Close icon always at the end (right side) -->
        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>

        <!-- Kebab menu content -->
        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu">
            @for (action of kebabMenuActions(); track action.id) {
            <button mat-menu-item (click)="executeAction(action)">
                <span class="flex items-center text-14-400 color-8">
                    <app-svg [name]="action.icon" class="ri-pe-3"
                        [color]="action.destructive ? ss.theme().color11 : (action.id === 'resetEntry' && isFormHasValue() ? ss.theme().color11 : (action.id === 'resetEntry' ? ss.theme().color4 : ss.theme().color35))"
                        role="button">
                    </app-svg>
                    {{ ss.textsAny()[action.label] || action.label }}
                </span>
            </button>
            }
        </mat-menu>
    </div>
</div>
<div class="habit-form" id="habitContentBlock" [ngClass]="{'deleted-habit': deleted()}">
    <div (click)="role() === 'viewer' || deleted() ? ds.noAccess($event) : null">
        <p class="text-14-400 color-12 mb-0 ri-px-4 ri-py-2 bg-29 flex items-center justify-between"
            *ngIf="remindingDays() !== null && !isHideRemainingDays() && this.cc.today().dateString === data.dateString">
            <span>{{ remindingDays() | parseRemainingDays }}</span>
            <span role="button" (click)="isHideRemainingDays.set(true)">{{ ss.texts()['common_dismiss'] }}</span>
        </p>
        <p class="text-14-400 color-14 mb-0 ri-px-4 ri-py-2 bg-28 text-center" *ngIf="!isValidEntry()">{{
            ss.texts()['actionCommon_invalidEntry'] }}</p>
        <form [formGroup]="habitForm" class="ri-p-4" #haForm="ngForm"
            [ngClass]="{'readonly' : role() === 'viewer' || deleted(), 'blocked' : deleted()}">
            <p class="color-8 text-18-500 ri-py-6 mb-0 w-full text-center">{{ setup().title }}</p>
            <div class="boolean-block ri-pb-5" *ngIf="habitType() === 'boolean'">
                <button class="btn-boolean text-16-400"
                    (click)="getFc('booleanAnswer').value === true ? getFc('booleanAnswer').setValue(null) : getFc('booleanAnswer').setValue(true)"
                    [ngClass]="{'active' : getFc('booleanAnswer').value === true }">
                    <span>{{ ss.texts()['common_yes'] }}</span>
                    <span class="check-circle"></span>
                </button>
                <button class="btn-boolean text-16-400"
                    (click)="getFc('booleanAnswer').value === false ? getFc('booleanAnswer').setValue(null) : getFc('booleanAnswer').setValue(false)"
                    [ngClass]="{'active' : getFc('booleanAnswer').value === false }">
                    <span>{{ ss.texts()['common_no'] }}</span>
                    <span class="check-circle"></span>
                </button>
            </div>
            <div class="options-block ri-pb-5" *ngIf="habitType() === 'single' || habitType() === 'multiple'">
                <button class="btn-option text-16-400" *ngFor="let option of setup().habitOptions"
                    [ngClass]="{'active' : getFc('singleAnswer').value === option.id || (habitType() === 'multiple' && getFc('multipleAnswer').value && getFc('multipleAnswer').value.includes(option.id)) }"
                    (click)="selectOption(option.id)">
                    <span>{{ option.value }}</span>
                    <span class=""
                        [ngClass]="{'check-circle' : habitType() === 'single', 'checkmark' : habitType() === 'multiple'}"></span>
                </button>
            </div>
            <div class="progress-block ri-pb-5" *ngIf="habitType() === 'timer'">
                <div class="flex justify-center ri-pb-4">
                    <div class="circular-progress" [style.background]="progressColor()">
                        <ng-container *ngFor="let angle of divisionAngles()">
                            <div class="circular-division absolute left-1/2 top-1/2 w-[1.5px] h-[calc(50%+1px)] origin-top"
                                [ngStyle]="{ transform: 'rotate(' + angle + 'deg)' }" *ngIf="durationRepeatCount() > 1">
                            </div>
                        </ng-container>
                        <div class="progress-value">
                            <span class="text-14-400 color-8 block text-center"
                                [ngClass]="{'hidden' : duration().totalSeconds === 0}">{{ totalTimePercentage()
                                }}%</span>
                            <span class="text-24-500 color-8 block ri-py-4 text-center">{{ (totalSecondsSpent() +
                                timerSeconds()) | timeFormat
                                }}</span>
                            <span class="text-14-400 color-7 flex items-center justify-center ri-px-4"
                                [ngClass]="{'hidden' : duration().totalSeconds === 0}">
                                <span class="ri-pe-1">{{ duration().totalSeconds | timeFormat }}</span>
                                <span>x {{ setup().durationRepeatCount }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="value-block flex items-center justify-between" *ngFor="let value of reversedTimerAnswers()">
                    <span class="text-14-400 color-8" *ngIf="value.startTimestamp && value.endTimestamp">{{
                        value.startTimestamp | timeFormat:value.endTimestamp
                        }}</span>
                    <div class="flex items-center">
                        <span class="text-14-400 color-7 ri-pe-4">{{ ss.getFormattedDate(value.startTimestamp, 'h:mm a')
                            }}</span>
                        <app-svg name="trash" [color]="ss.theme().color7" role="button"
                            (click)="deleteTimerValue(value)"></app-svg>
                    </div>
                </div>
            </div>
            <div class="progress-block ri-pb-5" *ngIf="habitType() === 'numeric'">
                <div class="flex justify-center ri-pb-4">
                    <div class="circular-progress" [style.background]="progressColor()">
                        <div class="progress-value">
                            <span class="text-24-500 color-8 block ri-py-4 text-center">{{ totalNumericValue() }}</span>
                            <span class="text-14-400 color-7 block text-center ri-px-4">{{ setup().numericGoal ?
                                ss.interpolateText('habitActionHabitTypeNumericalValue_withGoal', { target:
                                setup().numericGoal + ' ' + setup().numericUnit }) : setup().numericUnit }}</span>
                        </div>
                    </div>
                </div>
                <div class="value-block flex items-center justify-between"
                    *ngFor="let value of reversedNumericAnswers()" (click)="addNumericValue(value)" role="button">
                    <span class="text-14-400 color-8">{{ value.value }} {{ setup().numericUnit }}</span>
                    <div class="flex items-center">
                        <span class="text-14-400 color-7 ri-pe-4">{{ ss.getFormattedDate(value.timestamp, 'h:mm a')
                            }}</span>
                        <app-svg name="trash" [color]="ss.theme().color7" role="button"
                            (click)="$event.stopPropagation();deleteNumericValue(value)"></app-svg>
                    </div>
                </div>
            </div>
            <app-input-text-editor class="ri-pb-5" [maxLength]="20000" *ngIf="isDescription"
                [control]="getFc('description')" name="meHabitDescription"
                [placeholder]="ss.texts()['common_description']" [readonly]="role() === 'viewer'" [accessAlert]="true"
                [blocked]="deleted()" [defaultValue]="habitInitial.description" (focusEvent)="editorFocused.set($event)"
                (formatEvent)="activeFormats.set($event)"
                (dropdownPositionEvent)="onDropdownPosition($event)"></app-input-text-editor>
            <app-input-hashtag class="ri-pb-5" *ngIf="hashtags.length > 0 && role() === 'owner'"
                [control]="getFc('tags')" [setupHashtags]="setup().tags" [blocked]="deleted()"></app-input-hashtag>
            <div class="ri-py-4" *ngIf="habitType() !== 'timer' && habitType() !== 'numeric'"></div>
            <p class="text-14-400 color-7 text-end"
                *ngIf="mode() === 'edit' && isCollab() && !hasChanges() && !deleted()">{{ getLastUpdatedByText() }}</p>
        </form>

    </div>


    <div class="habit-addons ri-px-4">
        @if(!deleted()){
        <div class="add-button flex items-center justify-between"
            [ngClass]="{'timer-started' : habitType() === 'timer' && timerState()}" *ngIf="isAddFab()">
            <div class="timer-second ri-ps-4 whitespace-nowrap" *ngIf="habitType() === 'timer'">
                <span class="text-14-400 color-12 block text-center">{{ timerSeconds() | timeFormat }} <span
                        [ngClass]="{'hidden' : duration().totalSeconds === 0 || roundCompleteSecondsLeft() === 0}">/ {{
                        roundCompleteSecondsLeft() | timeFormat }}</span></span>
            </div>

            <button class="btn ml-auto"
                (click)="habitType() === 'numeric' ? addNumericValue() : timerState() ? stopTimer() : startTimer()">
                <app-svg [name]="habitType() === 'numeric' ? 'plus' : timerState() ? 'pause' : 'play'"></app-svg>
            </button>

        </div>
        }
        <div class="habit-addons-inner"
            [ngClass]="{'ri-pb-4' : (attachmentValues && attachmentValues.length > 0) || (mode() === 'edit' && isCollab() && !hasChanges() && !deleted())}">
            <app-attachment-list class="ri-pt-4" [title]="setup().title"
                *ngIf="attachmentValues && attachmentValues.length > 0" [attachments]="attachmentValues"
                (deleteEvent)="deleteAttachments($event)" [entityId]="habitInitial.id" [entityName]="'habit'"
                [uid]="habitInitial.uid" [blocked]="deleted()" [viewOnly]="role() === 'viewer'"
                [blocked]="deleted()"></app-attachment-list>
        </div>
    </div>
</div>
<div class="bottom-section flex items-center justify-between ri-p-4 text-end ri-bt-2" *ngIf="!deleted()">
    <div class="flex items-center">
        <!-- Text editor toolbar: Shows on both desktop and mobile -->
        <app-text-editor-options *ngIf="editorFocused()" [activeFormats]="activeFormats()"
            [position]="dropdownPosition()" (closeEvent)="onToolbarClose($event)"
            (editOptionsEvent)="editOptions($event.opt, $event.value)"></app-text-editor-options>
        <div class="flex items-center">
            <app-svg *ngIf="!isDescription && role() !== 'viewer'" name="description" [color]="ss.theme().color35"
                class="ri-pe-6" role="button" (click)="addDescription()"></app-svg>
            <app-svg *ngIf="hashtags.length === 0 && role() === 'owner'" name="hashtag" [color]="ss.theme().color35"
                class="ri-pe-6" role="button" (click)="openHashtagsDialog()"></app-svg>
            <app-input-file [attachments]="newAttachments" [multiple]="true" *ngIf="role() !== 'viewer'"
                class="ri-pe-6"></app-input-file>
        </div>
    </div>
    <button type="submit" class="btn-text text-16-500 color-35" (click)="hasChanges() ? save() : closeDialog()">{{
        hasChanges() ? ss.texts()['common_save'] : ss.texts()['common_close'] }}</button>
</div>